import { all } from "redux-saga/effects";
import authSaga from "./authSaga";
import iapSaga from "./iapSaga";

function* rootSaga() {
  yield all([
    authSaga(),
    iapSaga(),
  ]);
}

export default rootSaga;
